// Module
var code = "<button class=\"button is-small\" d-currency-symbol=\":currencySymbol\"> <span class=\"icon is-small is-hidden\"> <i class=\"fa-solid fa-check\"></i> </span> <span>:currencySymbol</span> </button> ";
// Exports
export default code;